import './index.css';
import './assets/css/invite_playbook.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'react-toastify/dist/ReactToastify.css';
import 'devextreme/dist/css/dx.light.css';
import './i18n';
import { TourProvider } from '@reactour/tour';

const getSteps = () => {
  return [
    {
      selector: '#askAiButton',
      content: (
        <div className="tour-text-content">You can use AI Tool with Ask AI</div>
      ),
      action: () => {
        document.getElementById('askAiButton')?.click();
      },
    },
    {
      selector: '#tabGeneral',
      content: (
        <div className="tour-text-content">
          By clicking on General, you can ask questions about dealspaces and
          workstreams.
        </div>
      ),

      action: () => {
        document.getElementById('tabGeneral')?.click();
      },
    },

    {
      selector: '#aiMessageInput',
      content: (
        <div className="tour-text-content">
          You can type your questions in here.
        </div>
      ),
    },

    {
      selector: '#tabDocument',
      content: (
        <div className="tour-text-content">
          Use the power of AI- get insights, and summaries from documents.
        </div>
      ),

      action: () => {
        document.getElementById('tabDocument')?.click();
      },
    },

    {
      selector: '#tabKnowledgebase',
      content: (
        <div className="tour-text-content">
          Leverage the power of Mergeflo's M&A knowledge base and expertly
          crafted prompts and files to broaden your perspective and deepen
          insights for your project.
        </div>
      ),

      action: () => {
        document.getElementById('tabKnowledgebase')?.click();
      },
    },
    {
      selector: '#tabWorkplan',
      content: (
        <div className="tour-text-content">
          In the Workplan section, you can access detailed prompts related to
          your workstream and dealspace.
        </div>
      ),

      action: () => {
        document.getElementById('tabWorkplan')?.click();
      },
    },
    {
      selector: '#dashBoardNavigation',
      content: (
        <div className="tour-text-content">
          You can see your workstream stats and graphs on Dashboard
        </div>
      ),
      action: () => {
        document.getElementById('closeAi')?.click();
      },
    },
    {
      selector: '#notificationsNav',
      content: (
        <div className="tour-text-content">
          You can follow your notifications
        </div>
      ),
    },
    {
      selector: '#milestonesNav',
      content: (
        <div className="tour-text-content">
          You can see track your milestones
        </div>
      ),
    },
    {
      selector: '#myTasksNav',
      content: (
        <div className="tour-text-content">
          You can track your assigned tasks.
        </div>
      ),
    },
    {
      selector: '#dealspaceDirectoryNav',
      content: (
        <div className="tour-text-content">
          You can invite your team with Invite To Deal
        </div>
      ),
    },
  ];
};

ReactDOM.render(
  <React.StrictMode>
    <TourProvider
      steps={getSteps()}
      position="bottom"
      showBadge={false}
      className="tour-content"
    >
      <App />
    </TourProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
